import { combineReducers } from 'redux';
import travellersReducer from './travellers/reducers';
const rootReducer = combineReducers({
    travellers: travellersReducer
});
export default rootReducer;
